import React from "react";
import useGlobalHook from "use-global-hook";

import * as actions from "../Actions/EditorialActions";

const initialState = {
  status: 200,
  isLoading: false,
  message: "",
  header: {},
  data: [],
  usersStatus: [],
  lastPage: false,
  refresh: false,
  type: [],
  module: [],
};

const EditorialStore = useGlobalHook(React, initialState, actions);

export default EditorialStore;
